// src/components/Toast.js
import React, { useEffect, useState } from "react";

export function emitToast(message, type = "info", timeout = 3000) {
  window.dispatchEvent(
    new CustomEvent("familyvault-toast", {
      detail: { message, type, timeout },
    })
  );
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    function handler(e) {
      const { message, type, timeout } = e.detail;
      const id = Date.now() + Math.random();
      setToasts((s) => [...s, { id, message, type }]);
      setTimeout(() => {
        setToasts((s) => s.filter((t) => t.id !== id));
      }, timeout || 3000);
    }
    window.addEventListener("familyvault-toast", handler);
    return () => window.removeEventListener("familyvault-toast", handler);
  }, []);

  const borderColor = (type) => {
    if (type === "success") return "#22c55e";
    if (type === "error") return "#ef4444";
    if (type === "warning") return "#f59e0b";
    return "var(--accent)";
  };

  return (
    <div
      style={{
        position: "fixed",
        right: 20,
        bottom: 20,
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        gap: 10,
        alignItems: "flex-end",
      }}
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          style={{
            minWidth: 240,
            maxWidth: 340,
            padding: "12px 16px",
            borderRadius: 10,
            backgroundColor: "var(--card)",
            color: "var(--text)",
            boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
            fontWeight: 600,
            fontSize: 14,
            borderLeft: `4px solid ${borderColor(t.type)}`,
            borderTop: "1px solid var(--border)",
            borderRight: "1px solid var(--border)",
            borderBottom: "1px solid var(--border)",
          }}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}